import { asLazy } from 'shared/utils/lazy.utils.js';

export { IssueModal } from './components/modals/IssueModal/index.js';
export {
  getPermissions,
  PermissionContext,
  type UserPermissions,
} from './utils/permissions.js';

export const HoldingsPage = asLazy(
  import('./pages/HoldingsPage/index.js'),
  'HoldingsPage',
);
export const UnitPage = asLazy(
  import('./pages/UnitPage/UnitPage.js'),
  'UnitPage',
);
export const PublicUnitsPage = asLazy(
  import('./pages/PublicUnitsPage/index.js'),
  'PublicUnitsPage',
);
